module.exports = __webpack_public_path__ + "static/media/rollet_vert.3bea7197.png";